var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCcw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18181 4.36431C5.9111 2.93764 8.51985 1.5 12 1.5C17.8328 1.5 22.5 6.20208 22.5 12C22.5 12.2761 22.2761 12.5 22 12.5C21.7239 12.5 21.5 12.2761 21.5 12C21.5 6.75223 17.2783 2.5 12 2.5C8.81348 2.5 6.42223 3.81236 4.81819 5.13569C4.01582 5.79764 3.41402 6.45974 3.0139 6.95489C3.00161 6.97009 2.98952 6.98513 2.97762 7H5.5C5.77614 7 6 7.22386 6 7.5C6 7.77614 5.77614 8 5.5 8H2C1.72386 8 1.5 7.77614 1.5 7.5V4C1.5 3.72386 1.72386 3.5 2 3.5C2.27614 3.5 2.5 3.72386 2.5 4V6.01019C2.91778 5.5252 3.47818 4.9448 4.18181 4.36431ZM2 11.5C2.27614 11.5 2.5 11.7239 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C14.5909 21.5 16.7273 20.2089 18.2404 18.8749C18.9936 18.2109 19.5811 17.5459 19.9799 17.0471C19.9926 17.0312 20.0051 17.0155 20.0174 17H17.5C17.2239 17 17 16.7761 17 16.5C17 16.2239 17.2239 16 17.5 16H21C21.2761 16 21.5 16.2239 21.5 16.5V20C21.5 20.2761 21.2761 20.5 21 20.5C20.7239 20.5 20.5 20.2761 20.5 20V17.9891C20.0934 18.4707 19.5568 19.0476 18.9017 19.6251C17.2955 21.0411 14.9319 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 11.7239 1.72386 11.5 2 11.5Z",
    fill: "#0A213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcw);
export default __webpack_public_path__ + "static/media/refresh-ccw.4796ec48b038c5996b0723ab7969533e.svg";
export { ForwardRef as ReactComponent };